import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var submitQuizRes;
export const submitQuizTodo = createAsyncThunk('submitQuiz', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/submit_question',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "email_id": user_id.vemail,
                "training_id": val.training_id,
                "course_id": val.course_id,
                "quiz_id": val.quiz_id,
                "learner_quiz_id": val.learner_quiz_id,
                "quiz": val.quiz,
                "passing_marks": val.passing_marks,
                "total_marks": val.total_marks,
                "fk_training_id": val.fk_training_id,
                "order": val.order,
                "device_token": user_id.vdevice_token

            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return submitQuizRes = res.data
    } catch (error) {
        return submitQuizRes = error.response.data
    }
})